/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react'
import { Theme, useTheme } from '@maas-components/styles'
import { useMediaQuery, Typography } from '@material-ui/core'
import Drawer from '@material-ui/core/Drawer'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import MenuIcon from '@material-ui/icons/Menu'
import clsx from 'clsx'
import ToolBar from '../Toolbar'
import MenuLinks from './MenuLinks'
import useStyles from './style'
import { TSidebarDrawerProps } from './types'

const SidebarDrawer = ({
  menu,
  version,
  options,
  setOptions,
  onClickMenuItem,
}: TSidebarDrawerProps) => {
  const theme: Theme = useTheme()
  const { isOpen, isOpenFromMenu } = options
  const isDownMD = useMediaQuery((muiTheme: Theme) => muiTheme.breakpoints.down(1540))
  const isDownSM = useMediaQuery((muiTheme: Theme) => muiTheme.breakpoints.down(1324))

  const classes = useStyles()

  // faz controle manual do menu
  // apos clicar no botão o menu não fecha nem abre mais automaticamente somente com click
  useEffect(() => {
    if (!isOpenFromMenu) setOptions({ ...options, isOpen: !isDownMD })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // quando menu esta fechado, podemos clicar em qualquer parte para abrir novamente
  const handleToggleNavigation = () => {
    if (!isOpen) setOptions({ ...options, isOpen: !isOpen, isOpenFromMenu: true })
  }

  const handleCloseMenuManual = () => {
    setOptions({
      ...options,
      isOpen: !isOpen,
      isOpenFromMenu: true,
    })
  }

  // customiza o wrapper do drawer
  const cssDrawer = clsx(classes.drawer, {
    [classes.drawerOpen]: isOpen,
    [classes.drawerClose]: !isOpen,
  })

  // customiza o paper do drawer
  const cssPaper = clsx(classes.drawer, {
    [classes.drawerOpen]: isOpen,
    [classes.drawerClose]: !isOpen,
  })

  const flutuante = useMediaQuery((muiTheme: Theme) => muiTheme.breakpoints.between(1324, 1540))

  let tipo: 'permanent' | 'persistent' | 'temporary' | undefined = 'permanent'

  if (isOpen && flutuante) tipo = undefined
  if (!isOpen && flutuante) tipo = 'permanent'

  const handleCloseOnClick = () => {
    setOptions({ ...options, isOpen: false })
  }

  return (
    <Drawer
      elevation={3}
      onClick={handleToggleNavigation}
      className={cssDrawer}
      classes={{ paper: cssPaper }}
      variant={tipo}
      open={isOpen}
      style={{ zIndex: 1000 }}
      ModalProps={{
        hideBackdrop: true,
      }}
      PaperProps={{
        style: {
          backgroundColor: theme.palette.shell[theme.shellMode].sidebar.background,
        },
      }}
      SlideProps={{
        onEntering: node => {
          node.style.transition = theme.transitions.create(
            ['transform', 'margin', 'height', 'width', 'top', 'left'],
            {
              easing: theme.transitions.easing.easeInOut,
              duration: '0.3s',
            }
          )
        },
      }}
    >
      {isOpen ? (
        <>
          <div className={classes.menuContainer}>
            <div // eslint-disable-line jsx-a11y/no-static-element-interactions
              onClick={handleCloseMenuManual}
              onKeyDown={handleCloseMenuManual}
            >
              <div className={classes.menuIconClose}>
                {isDownSM ? (
                  <ExpandLessIcon />
                ) : (
                  <KeyboardArrowLeftIcon data-testid="close-sidebar" />
                )}
              </div>
              <div className={classes.menuTitle}>
                <div className={classes.menuIcon}>{menu.title.icon}</div>
                <div className={classes.menuName}>
                  <Typography>
                    <strong>{menu.title.name}</strong>
                  </Typography>
                </div>
              </div>
            </div>
            <MenuLinks
              menu={menu}
              onClickMenuItem={onClickMenuItem}
              handleCloseOnClick={handleCloseOnClick}
            />
          </div>
          <div className={classes.version}>
            <Typography>Desenvolvido por Luizalabs</Typography>
            {version && <Typography>Versão: {version}</Typography>}
          </div>
        </>
      ) : (
        <ToolBar
          title={menu.title.name}
          icon={<MenuIcon data-testid="icon-toggle-sidebar" />}
          options={options}
          setOptions={setOptions}
        />
      )}
    </Drawer>
  )
}

export default SidebarDrawer
